import type { AssistantChatResponse, AssistantMessage, AssistantStatus } from '@ldembalagens/types';
import { api } from '@/lib/api-client';

export const assistantApi = {
  status: () => api.get<AssistantStatus>('/assistant/status'),
  chat: (messages: AssistantMessage[]) =>
    api.post<AssistantChatResponse>('/assistant/chat', { messages }),
};

export const assistantKeys = {
  status: ['assistant', 'status'] as const,
};
